import { PersonAdd, Work } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { Column } from 'further-ui/components/Layout';
import Avatar from 'further-ui/components/Avatar';

type Props = {
  vehicleName: string;
  selectedInvestor?: {
    name: string;
  };
  isLegalEntity?: boolean;
};

const Header: React.FC<Props> = ({
  selectedInvestor,
  vehicleName,
  isLegalEntity,
}) => {
  const heading = selectedInvestor
    ? `Add ${selectedInvestor.name} to`
    : `Add investor to`;

  return (
    <Column spacing="xs" centered>
      {selectedInvestor ? (
        <Avatar color="random" text={selectedInvestor.name} size="lg" />
      ) : isLegalEntity ? (
        <Work fontSize="large" />
      ) : (
        <PersonAdd fontSize="large" />
      )}

      <Typography variant="h4" textAlign="center">
        {heading}
        <br />
        {vehicleName}
      </Typography>
    </Column>
  );
};

export default Header;
